import Details from "pages/Details";

export default function DetailsPage() {
  return <Details />;
}
